import {Component, Input, OnInit} from '@angular/core';
import {AlertController, NavController} from '@ionic/angular';
import {UserModel} from 'src/app/models/user.model';
import {AuthService} from 'src/app/services/auth/auth.service';
import {GlobalService} from 'src/app/services/global/global.service';
import {TeamService} from 'src/app/services/team/team.service';
import {ApiResponse} from 'src/app/services/utils';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-team-members',
    templateUrl: './team-members.component.html',
    styleUrls: ['./team-members.component.scss'],
    standalone: false
})
export class TeamMembersComponent implements OnInit {

  @Input() item: UserModel;
  @Input() teamId: number;
  @Input() isAdmin: boolean;
  user: UserModel;
  teamMemberVisible = true;
  memberType = 'member';

  constructor(
    private teamService: TeamService,
    private alertController: AlertController,
    private translate: TranslateService,
    private navController: NavController,
    private globalService: GlobalService,
    private auth: AuthService
  ) {
  }

  ngOnInit() {
    this.user = this.auth.user;
    if (this.item?.isAdmin) {
      this.memberType = 'admin';
    } else {
      this.memberType = 'member';
    }
  }

  changeTeamAdmin() {
    if (this.memberType === 'admin') {
      this.addTeamAdmin();
    } else if (this.memberType === 'member') {
      this.removeTeamAdmin();
    } else if (this.memberType === 'remove') {
      this.confirmRemoveTeam();
    }
  }

  async confirmRemoveTeam() {
    const str = this.translate.instant('txt_remove_from_your_team_check');
    const alert = await this.alertController.create({
      header: str.replace('$name', this.item.username),
      buttons: [
        {
          text: this.translate.instant('lbl_yes'),
          id: 'confirm-button',
          handler: () => {
            this.removeTeamMember();
          }
        },
        {
          text: this.translate.instant('lbl_no'),
          role: 'cancel',
          cssClass: 'cancel-button',
          id: 'cancel-button',
          handler: () => {

          }
        }
      ]
    });
    await alert.present();
  }

  removeTeamMember() {
    const data = {
      teamId: this.teamId,
      userId: this.item.id
    };

    this.teamService.apiRemoveTeamMember(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.teamMemberVisible = false;
        this.globalService.presentToast(result.message);
      }
    });
  }

  addTeamAdmin() {
    const data = {
      teamId: this.teamId,
      userId: this.item.id
    };

    this.teamService.apiAddTeamAdmin(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.memberType = 'admin';
        this.globalService.presentToast(result.message);
      }
    });
  }

  removeTeamAdmin() {
    const data = {
      teamId: this.teamId,
      userId: this.item.id
    };

    this.teamService.apiRemoveTeamAdmin(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.memberType = 'member';
        this.globalService.presentToast(result.message);
      }
    });
  }

  openOtherProfile(item) {
    if (item?.memberCompany) {
      if (item?.memberCompany?.isAdmin) {
        this.navController.navigateForward(['/app/team/company/view-company/' + item?.memberCompany.id]);
      } else {
        this.navController.navigateForward(['/app/team/company/other-company/' + item?.memberCompany.id]);
      }
    } else {
      this.navController.navigateForward(['/app/home/other-profile/' + item.id]);
    }
  }
}
